import React from "react";
import { NavLink, RouteComponentProps, withRouter } from "react-router-dom";
import { observable } from "mobx";
import { observer } from "mobx-react";
import classNames from "classnames";

export interface SelectedLinkProps {
  automationName?: string;
  scope?: string;
  to: string;
  children?: any;
  selector?: (pathname: string) => boolean;
}

@observer
class SelectedLink extends React.Component<SelectedLinkProps & RouteComponentProps> {
  @observable selected: boolean = false;
  _listener: any = null;

  componentWillMount() {
    this._listener = this.props.history.listen(this._changeState.bind(this));
    this._changeState();
  }

  componentWillUnmount() {
    if (this._listener) {
      this._listener();
    }
  }

  _changeState(e?: any) {
    let location = this.props.history.location;
    if (e) {
      location = e;
    }
    this.selected = this.props.selector
      ? this.props.selector(location.pathname)
      : location.pathname.startsWith(this.props.scope);
  }

  render() {
    const { to, children } = this.props;

    return (
      <NavLink
        to={to}
        data-automation-name={this.props.automationName}
        className={classNames({ selected: this.selected })}
      >
        {children}
      </NavLink>
    );
  }
}

export default withRouter(SelectedLink) as React.ComponentType<SelectedLinkProps>;
